import { createActions } from 'redux-actions';

export const { updatePageTemplates } = createActions('UPDATE_PAGE_TEMPLATES');
